package ru.it_mozaika.sender.js.application.context

import io.ktor.client.call.*
import js.core.jso
import react.*
import ru.it_mozaika.components.useSnackbar
import ru.it_mozaika.sender.common.models.Sender
import ru.it_mozaika.sender.common.models.Store
import ru.it_mozaika.sender.js.application.Http
import web.storage.sessionStorage

external interface StoreContextInterface {
    var storeList: List<Store>
    var currentStoreId: String?
    var currentStore: Store?
    var setStore: (String) -> Unit
    var updateStoreList: () -> Unit
    var sendersList: List<Sender>
}
val StoreContext = createContext<StoreContextInterface>(jso {
    storeList = listOf()
    currentStoreId = null
    currentStore = null
    setStore = {}
    updateStoreList = {}
    sendersList = listOf()
})
val StoreProvider = FC<PropsWithChildren> { props ->
    var currentStoreId by useState<String?>(sessionStorage.getItem("store") ?: "5e42cfbebbbe5a01224bc4ce")
    var list by useState<List<Store>>(emptyList())
    val currentStore = useMemo(currentStoreId, list) { list.find { it.id == currentStoreId } }
    var senders by useState(listOf<Sender>())
    fun loadStores() {
        Http.get("/stores") { response ->
            list = response.body()
        }
    }
    fun loadSenders(){
        Http.get("/senders") { response ->
            senders = response.body<List<Sender>>()
        }
    }

    StoreContext.Provider {
        value = jso {
            this.storeList = list
            this.currentStoreId = currentStoreId
            this.currentStore = currentStore
            this.setStore = { storeId ->
                currentStoreId = storeId
                if (storeId != "null")sessionStorage.setItem("store", storeId)
            }
            updateStoreList = { loadStores() }
            this.sendersList = senders
        }
        +props.children
    }
    useEffectOnce {
        loadStores()
    }
    useEffect(currentStoreId) {
        loadSenders()
    }
}
fun useStore() = useContext(StoreContext)